import React, { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import { useVideoTracking } from 'app/components/videoEmbeeds/useVideoTracking';
import is from '@sindresorhus/is';
const youtubeScriptId = 'youtube-embed';
const initYoutubeScript = () => {
  if (!document.getElementById(youtubeScriptId)) {
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    script.type = 'text/javascript';
    script.id = youtubeScriptId;
    document.head.appendChild(script);
  }
};
const VideoEmbedYoutube = _ref => {
  let {
    data,
    open
  } = _ref;
  const {
    trackEvent,
    setTrackEvent
  } = useVideoTracking(data.source, data.matchSlug, data.id, data.url);
  const playerRef = useRef(null);
  const playerId = useMemo(() => "ytplayer-".concat(data.uniqueId), [data.uniqueId]);
  const initPlayer = useCallback(() => {
    playerRef.current = new window.YT.Player(playerId, {
      height: '100%',
      width: '100%',
      videoId: data.uniqueId,
      playerVars: {
        'allow-presentation': true
      },
      events: {
        onStateChange: function (event) {
          if (event.data === window.YT.PlayerState.PLAYING && !trackEvent) {
            setTrackEvent(true);
          }
        }
      }
    });
  }, [data.uniqueId, trackEvent, setTrackEvent]);
  const destroyPlayer = useCallback(player => {
    if (!player) {
      return;
    }
    // destroy player on overlay close
    setTrackEvent(false);
    if (is.function_(player === null || player === void 0 ? void 0 : player.stopVideo)) {
      player.stopVideo();
    }
    player.destroy();
    playerRef.current = null;
  }, []);
  useLayoutEffect(() => {
    const player = playerRef.current;
    if (!open) {
      return;
    }
    // Check if Youtube API Script is already loaded and display video directly
    if (window.YT && window.onYouTubeIframeAPIReady) {
      window.YT.ready(() => initPlayer());
    } else {
      initYoutubeScript();
      window.onYouTubeIframeAPIReady = () => initPlayer();
    }
    return () => {
      destroyPlayer(player);
    };
  }, [open, initPlayer]);
  return /*#__PURE__*/React.createElement("div", {
    id: playerId,
    "data-sentry-component": "VideoEmbedYoutube",
    "data-sentry-source-file": "YoutubeEmbed.tsx"
  });
};
export { VideoEmbedYoutube };